(function () {
  const cards = Array.from(document.querySelectorAll(".expect__card"));
  if (!cards.length) return;

  const list = cards[0].closest(".expect__list");
  const stackedQuery = window.matchMedia("(max-width: 900px)");

  const STEP_DELAY = 4000;
  let sequenceStarted = false;

  function startSequence() {
    if (sequenceStarted) return;
    sequenceStarted = true;
    cards.forEach((card, i) => {
      setTimeout(() => card.classList.add("is-active"), i * STEP_DELAY);
    });
  }

  function onScroll() {
    const vh = window.innerHeight;

    if (stackedQuery.matches) {
      const line = vh * 0.6;
      cards.forEach((card) => {
        const rect = card.getBoundingClientRect();
        const cardMid = rect.top + rect.height / 2;
        card.classList.toggle("is-active", cardMid <= line);
      });
      return;
    }

    if (!list || sequenceStarted) return;
    const listRect = list.getBoundingClientRect();
    if (listRect.top <= vh * 0.75) startSequence();
  }

  let ticking = false;
  window.addEventListener(
    "scroll",
    () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          onScroll();
          ticking = false;
        });
        ticking = true;
      }
    },
    { passive: true },
  );
  window.addEventListener("resize", onScroll, { passive: true });
  if (stackedQuery.addEventListener) {
    stackedQuery.addEventListener("change", onScroll);
  } else if (stackedQuery.addListener) {
    stackedQuery.addListener(onScroll);
  }
  onScroll();
})();
